var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          class: `text-center ${_vm.isDetail ? "pb-8 pt-0" : "mt-n16"}`,
          attrs: { cols: "12" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "my-2",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c("v-img", {
                attrs: {
                  contain: "",
                  height: _vm.isDetail ? 260 : 400,
                  src: require(`@/assets/empty-state/appAsset-http--403-ax.svg`),
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              class: `d-block subtitle-2 font-weight-bold ${
                _vm.isDetail ? "mt-n5" : "mt-n9"
              }`,
            },
            [_vm._v("No tienes permisos para visualizar esta sección")]
          ),
          _c("span", { staticClass: "d-block grey-300--text subtitle-2" }, [
            _vm._v(
              "Ponte en contacto con el administrador para solicitar este permiso."
            ),
          ]),
          !_vm.isDetail
            ? _c(
                "v-btn",
                {
                  staticClass: "mt-5",
                  attrs: {
                    to: { name: "AccountDashboard" },
                    width: 220,
                    color: "grey-900",
                  },
                },
                [_vm._v("Volver al inicio")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }